/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CaseType
 */
export interface CaseType {
    /**
     * 
     * @type {string}
     * @memberof CaseType
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseType
     */
    typeCode?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseType
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseType
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseType
     */
    category?: CaseTypeCategoryEnum;
    /**
     * 
     * @type {string}
     * @memberof CaseType
     */
    defaultSeverity?: CaseTypeDefaultSeverityEnum;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CaseType
     */
    workflowConfig?: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CaseType
     */
    requiredFields?: { [key: string]: any; };
    /**
     * 
     * @type {Date}
     * @memberof CaseType
     */
    created?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CaseType
     */
    updated?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof CaseType
     */
    active?: boolean;
}


/**
 * @export
 */
export const CaseTypeCategoryEnum = {
    SecurityIncident: 'SECURITY_INCIDENT',
    Vulnerability: 'VULNERABILITY',
    Compliance: 'COMPLIANCE',
    RiskAssessment: 'RISK_ASSESSMENT',
    Support: 'SUPPORT',
    ThreatIntelligence: 'THREAT_INTELLIGENCE',
    Audit: 'AUDIT',
    General: 'GENERAL',
    ChangeRequest: 'CHANGE_REQUEST'
} as const;
export type CaseTypeCategoryEnum = typeof CaseTypeCategoryEnum[keyof typeof CaseTypeCategoryEnum];

/**
 * @export
 */
export const CaseTypeDefaultSeverityEnum = {
    Critical: 'CRITICAL',
    High: 'HIGH',
    Medium: 'MEDIUM',
    Low: 'LOW',
    Info: 'INFO'
} as const;
export type CaseTypeDefaultSeverityEnum = typeof CaseTypeDefaultSeverityEnum[keyof typeof CaseTypeDefaultSeverityEnum];


/**
 * Check if a given object implements the CaseType interface.
 */
export function instanceOfCaseType(value: object): value is CaseType {
    return true;
}

export function CaseTypeFromJSON(json: any): CaseType {
    return CaseTypeFromJSONTyped(json, false);
}

export function CaseTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaseType {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'typeCode': json['typeCode'] == null ? undefined : json['typeCode'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'description': json['description'] == null ? undefined : json['description'],
        'category': json['category'] == null ? undefined : json['category'],
        'defaultSeverity': json['defaultSeverity'] == null ? undefined : json['defaultSeverity'],
        'workflowConfig': json['workflowConfig'] == null ? undefined : json['workflowConfig'],
        'requiredFields': json['requiredFields'] == null ? undefined : json['requiredFields'],
        'created': json['created'] == null ? undefined : (new Date(json['created'])),
        'updated': json['updated'] == null ? undefined : (new Date(json['updated'])),
        'active': json['active'] == null ? undefined : json['active'],
    };
}

export function CaseTypeToJSON(json: any): CaseType {
    return CaseTypeToJSONTyped(json, false);
}

export function CaseTypeToJSONTyped(value?: CaseType | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'typeCode': value['typeCode'],
        'displayName': value['displayName'],
        'description': value['description'],
        'category': value['category'],
        'defaultSeverity': value['defaultSeverity'],
        'workflowConfig': value['workflowConfig'],
        'requiredFields': value['requiredFields'],
        'created': value['created'] == null ? undefined : ((value['created']).toISOString()),
        'updated': value['updated'] == null ? undefined : ((value['updated']).toISOString()),
        'active': value['active'],
    };
}

